module.exports = __webpack_public_path__ + "static/img/modal2310.04cab45.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/img/modal2310.png
// module id = Crk1
// module chunks = 7